import { Box, Flex, Skeleton } from '@backstage/ui';
import styles from './loading-state.module.css';

interface LoadingStateProps {
  template?: 'list' | 'entity';
  rows?: number;
  columns?: number;
}

const CELL_WIDTHS = ['70%', '55%', '80%', '45%', '60%', '50%'];

export const LoadingState = ({
  template = 'list',
  rows = 5,
  columns = 4,
}: LoadingStateProps) => {
  if (template === 'entity') {
    return (
      <Flex direction="column" gap="3">
        <Skeleton width="40%" height={24} />
        <Skeleton width="100%" height={120} rounded />
        <Flex direction="column" gap="2">
          <Skeleton width="60%" height={16} />
          <Skeleton width="80%" height={16} />
          <Skeleton width="50%" height={16} />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="0">
      {/* Header row */}
      <Flex gap="4" className={styles.headerRow}>
        {Array.from({ length: columns }, (_, c) => (
          <Box key={c} className={styles.cell}>
            <Skeleton width="60%" height={12} />
          </Box>
        ))}
      </Flex>

      {/* Data rows */}
      {Array.from({ length: rows }, (_row, r) => (
        <Flex key={r} gap="4" className={styles.dataRow}>
          {Array.from({ length: columns }, (_col, c) => (
            <Box key={c} className={styles.cell}>
              <Skeleton width={CELL_WIDTHS[(r + c) % CELL_WIDTHS.length]} height={14} />
            </Box>
          ))}
        </Flex>
      ))}
    </Flex>
  );
};
